export default function () {
  return {
    date: null,
    tableGenerator: [],
    visibleColumns: ['state', 'code', 'date', 'start', 'end', 'actions'],
    detailVisibleColumns: ['numero', 'operacion', 'serie', 'cliente_email', 'tipo_de_comprobante', 'sunat_transaction', 'fecha_de_emision', 'total', 'state', 'actions'],
  }
}
